<div class="md:hidden pb-4 h-[auto]">
	<app-main-header
		><h1 class="text-lg p-3">
			<span class="text-accentColor">{{ title() }} </span><span class="text-mainColor">{{ titleSuffix() }}</span>
		</h1></app-main-header
	>

	@let offerList = offerList$ | async;
	@if (!!offerList?.length && !!offerList) {
		<swiper [config]="swiperConfig">
			@for (offer of offerList; track offer.product.id; let i = $index) {
				<ng-template swiperSlide>
					<app-mobile-wrapper>
						<app-offer-box-mobile-horizontal
							[offer]="offer"
							class="md:hidden"
						></app-offer-box-mobile-horizontal>
					</app-mobile-wrapper>
				</ng-template>
			}
		</swiper>
	} @else {
		<app-main-loader></app-main-loader>
	}
</div>
